import React from 'react'
import { PromotionalCard } from '../../cards/PromotionalCard/PromotionalCard'
import { ContentDataDefinitionLoader } from '@news-mono/web-common'
import { CardRouteProps } from '../../cards/card-props.routing'
import { ImpressionAvailable } from '../../__helpers/impression-available-helper'
import { MediaMode } from '../CardMedia/CardMedia'
import { createRegisterableComponentWithData } from '@news-mono/web-common'
import { createCollectionAvailableEvent } from '@news-mono/web-common'
import { ThemeMargins } from '../../__styling/settings/metrics'
import { FixedRatio, CardBreakpointRatios } from '@news-mono/web-common'

type PromotionalCardRoutingProps = CardRouteProps & {
    fixedRatio?: FixedRatio | FixedRatio[] | CardBreakpointRatios
    verticalSpacing?: keyof ThemeMargins
    hasPadding?: boolean
    mediaMode?: MediaMode
    showCTA?: boolean
    mobileOnly?: true
}

export const PromotionalCardRegistration = createRegisterableComponentWithData(
    'promotional-card',
    ContentDataDefinitionLoader,
    (props: PromotionalCardRoutingProps, data, services) => {
        if (!data.loaded) {
            return null
        }

        if (data.loaded && data.result.publications.length === 0) {
            // Can happen if we are driven by a curation and publication(s) have been killed
            // or curation metadata which can be empty by choice
            return null
        }

        const results = data.loaded && data.result.publications[0]
        if (results && results.cardType !== 'publication') {
            return null
        }

        const promotionType = results && results.promotionType

        return (
            <ImpressionAvailable
                loading={!data.loaded}
                available={() => {
                    if (!data.loaded) {
                        console.warn(
                            'Available should never be called when loading is true',
                        )
                        return
                    }

                    services.onEvent(
                        createCollectionAvailableEvent(
                            data.result.publications,
                            'PromotionalCard',
                        ),
                    )
                }}
            >
                {(ref) => (
                    <PromotionalCard
                        innerRef={ref}
                        item={
                            results
                                ? { loaded: true, result: results }
                                : { loaded: false }
                        }
                        fixedRatio={props.fixedRatio}
                        fontScale={props.fontScale}
                        onEvent={services.onEvent}
                        hasPadding={props.hasPadding}
                        verticalSpacing={props.verticalSpacing}
                        cardNumber={1}
                        mediaMode={props.mediaMode}
                        showCTA={props.showCTA}
                        mobileOnly={props.mobileOnly}
                        promotionType={
                            promotionType ? promotionType : undefined
                        }
                    />
                )}
            </ImpressionAvailable>
        )
    },
)
